export interface IOrder {
  paymentReference?: string;
  amountPaid?: string;
  paymentDate?: Date;
  statut?: string;
  listRefInternes?: string;
}

export class Order implements IOrder {
  constructor(
    public paymentReference?: string,
    public amountPaid?: string,
    public paymentDate?: Date,
    public statut?: string,
    public listRefInternes?: string
  ) {
  }
}
